import { Pipe, PipeTransform } from '@angular/core';
import {  Widget } from 'src/api/models';

@Pipe({
  name: 'visiblewidget',
  pure: false
})
export class VisibleWidgetPipe implements PipeTransform {

  transform(widgets: Widget[], editing: boolean): Widget[] | undefined {
    if (widgets) {
      return widgets.filter(id => !(id.hidden && id.hideWhenNoData) || editing);
    }
    return null;
  }

}
